import { Component, Input } from '@builder.io/sdk';

import { formFields } from 'molecules/Form/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

const conversionHeroFields = [
  // ── Left Column: Frosted Card ──────────────────────────
  {
    name: 'eyebrow',
    type: 'string',
    defaultValue: 'SCHEDULE A DEMO TODAY',
    helperText: 'Short uppercase label above the heading inside the card.',
  },
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Build Customer-Facing Integrations 10× Faster',
    helperText: 'Main heading inside the frosted glass card. Supports <br /> for line breaks.',
  },
  {
    name: 'headingAs',
    type: 'string',
    enum: [
      { label: 'H1', value: 'h1' },
      { label: 'H2', value: 'h2' },
    ],
    defaultValue: 'h1',
    helperText: 'Semantic heading level for the card heading.',
  },
  {
    name: 'cardBody',
    type: 'longText',
    defaultValue: 'Book a 45-minute walkthrough tailored to your integration needs.',
    helperText: 'Body text below the heading inside the card.',
  },
  ...formFields(),

  // ── Right Column: Content ──────────────────────────────
  {
    name: 'description',
    type: 'richText',
    helperText: 'Description paragraph displayed on the right column.',
  },
  {
    name: 'testimonial',
    type: 'object',
    helperText: 'Testimonial quote with company logo, shown on the right column.',
    subFields: [
      {
        name: 'quote',
        type: 'longText',
        helperText: 'The testimonial quote text.',
      },
      imageField('logo'),
    ],
  },
  {
    name: 'checkItems',
    type: 'list',
    helperText: 'Checkmark list items displayed below the testimonial.',
    subFields: [
      {
        name: 'text',
        type: 'string',
        required: true,
        helperText: 'Text for this checkmark item.',
      },
    ],
  },

  // ── Background ─────────────────────────────────────────
  imageField('backgroundImage'),

  // ── Bottom Logo Bar ────────────────────────────────────
  imageField('logosImage'),

  // ── Section fields ─────────────────────────────────────
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const conversionHeroConfig = {
  name: 'ConversionHero',
  inputs: conversionHeroFields,
} as Component;

export interface ConversionHeroProps
  extends Omit<GenerateBuilder<typeof conversionHeroFields>, 'form'>, FormFieldProps {}

export default conversionHeroConfig;
